import React from "react"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"

import * as PartnerApi from "features/Partner/api/PartnerApi"
import { privateRoutes } from "router/routes"

import { useBikeStoreProcess, useAlert } from "hooks"
import { ErrorResponse } from "models"

export const PartnerLink = () => {
	const { bikeProcessState } = useBikeStoreProcess()
	const { currentBike: bike } = bikeProcessState
	const [partnerEntityLink, setPartnerEntityLink] = React.useState(null)

	const { t } = useTranslation()
	const { alert } = useAlert()

	const fetchOldPartner = async (storeId) => {
		try {
			const { res: getOldPartner, getError } = await PartnerApi.getOldPartner(storeId)
			if (getError()) throw getError()
			if (getOldPartner) setPartnerEntityLink(getOldPartner.entity_id)
		} catch (error) {
			//console.error(error)
			const erroMsg = (error as ErrorResponse)?.message?.toString()
			if (erroMsg) alert("error", erroMsg)
		}
	}

	React.useEffect(() => {
		const bikeStoreId = bike?.bike_last_registered_by?.store_id

		if (bikeStoreId) {
			if (bikeStoreId.startsWith("ST-")) {
				// It's a bike from a new partner
				setPartnerEntityLink(bikeStoreId.slice(3))
			} else {
				//I t's a bike from an old partner
				fetchOldPartner(bikeStoreId)
			}
		}
	}, [bike]) // eslint-disable-line

	return (
		<div className="c-card p-5 md:p-12 mb-7">
			<h2 className="c-h2 font-semibold mb-5 uppercase">
				{t("registrered_by", { ns: "bike" })}
			</h2>
			<p>
				{bike.bikeSeller && <strong>{bike.bikeSeller} : </strong>}

				{partnerEntityLink ? (
					<NavLink
						to={privateRoutes.partner.basePath + "/" + partnerEntityLink}
						className="underline"
					>
						{t("see_partner", { ns: "bike" })}
					</NavLink>
				) : (
					t("no_partner_view", { ns: "bike" })
				)}
			</p>
		</div>
	)
}
